"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampusApiService = void 0;
const axios_1 = require("axios");
const abstract_service_1 = require("../shared/abstract-service");
class CampusApiService extends abstract_service_1.AbstractService {
    constructor(baseUrl, headerRetrievalFunction) {
        super(baseUrl, headerRetrievalFunction);
        this.campusUrl = `${this.baseUrl}/campuses`;
        this.areaUrl = (campusId) => `${this.campusUrl}/${campusId}/areas`;
        this.roomUrl = (campusId, areaId) => `${this.areaUrl(campusId)}/${areaId}/rooms`;
        this.attachmentUrl = (campusId, areaId, roomId) => `${this.roomUrl(campusId, areaId)}/${roomId}/attachments`;
        this.changelogUrl = `${this.baseUrl}/changelog`;
    }
    createCampus(provider, orgId, name, domain) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.campusUrl}`, {
                identityProvider: provider,
                orgId: orgId,
                name: name,
                domain: domain
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getCampusById(campusId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.campusUrl}/${campusId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateCampus(campusId, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const { name } = changes;
            const response = yield axios_1.default.patch(`${this.campusUrl}/${campusId}`, {
                name: name
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    createArea(campusId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.areaUrl(campusId)}`, {
                name: name
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getAllForCampus(campusId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.areaUrl(campusId)}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getAreaById(campusId, areaId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.areaUrl(campusId)}/${areaId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateArea(campusId, areaId, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const { name } = changes;
            const response = yield axios_1.default.patch(`${this.areaUrl(campusId)}/${areaId}`, {
                name: name
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    deleteArea(campusId, areaId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.delete(`${this.areaUrl(campusId)}/${areaId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 204) {
                throw new Error(response.statusText);
            }
        });
    }
    createRoom(campusId, areaId, attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.roomUrl(campusId, areaId)}`, attributes, {
                headers: this.getHeaders()
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getAllForArea(campusId, areaId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.roomUrl(campusId, areaId)}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getRoomById(campusId, areaId, roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.roomUrl(campusId, areaId)}/${roomId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateRoom(campusId, areaId, roomId, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.roomUrl(campusId, areaId)}/${roomId}`, changes, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    archiveRoom(campusId, areaId, roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.roomUrl(campusId, areaId)}/${roomId}/archive`, { isArchived: true }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
        });
    }
    getAllForRoom(campusId, areaId, roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.attachmentUrl(campusId, areaId, roomId)}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getAttachmentById(campusId, areaId, roomId, attachmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.attachmentUrl(campusId, areaId, roomId)}/${attachmentId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    createAttachment(campusId, areaId, roomId, addOnName, ref, isOpenForVisitors) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.attachmentUrl(campusId, areaId, roomId)}`, {
                addOnName: addOnName,
                ref: ref,
                isOpenForVisitors: isOpenForVisitors
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 201) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateAttachment(campusId, areaId, roomId, attachmentId, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.patch(`${this.attachmentUrl(campusId, areaId, roomId)}/${attachmentId}`, changes, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    deleteAttachment(campusId, areaId, roomId, attachmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.delete(`${this.attachmentUrl(campusId, areaId, roomId)}/${attachmentId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 204) {
                throw new Error(response.statusText);
            }
        });
    }
    getAllChangelogs() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.changelogUrl}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getChangelogById(changelogId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.changelogUrl}/${changelogId}`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
}
exports.CampusApiService = CampusApiService;
